<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="pincode_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Address Pin Code</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Pin Code</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field 
                      v-model="editedItem.pincode" 
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: 411011, 411022':'For example :: 411011, 411022'"
                      :filled="editedIndex==-1?false:true"
                      label="Pin Code"
                      :error="errorMsg.pincode?true:false"
                      :error-messages="errorMsg.pincode?'Required':''"
                    ></v-text-field>
                  </v-col> -->
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete :items="pin_super_master_list" v-model="addedItem.pin_super_master_list"
                            label="Select Pin Code" :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.pincode" persistent-hint :disabled="editedIndex != -1"
                            :hint="
                              editedIndex == -1
                                ? 'For example ::411011, 411022'
                                : 'noneditable'
                            " label="Pin Code" :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" >Pincode
                          <v-select dense
                            v-model="editedItem.pincode"
                            :items="pin_super_master_list"                            
                            item-text="pin_super_master_list_id"
                            item-value="id"
                            persistent-hint
                            :disabled="editedIndex != -1"
                            :hint="editedIndex==-1?'For example :: 411011, 411022':'noneditable'"
                            :filled="editedIndex==-1?false:true"
                            :error="errorMsg.pincode?true:false"
                            :error-messages="errorMsg.pincode?'Required':''"
                          ></v-select>
                        </v-col> -->
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      pincode: false,
    },
    snackbar_msg: "",
    color: "",
    // extraBreadcrumbItems: [
    //   { text: "PinCode Master", disabled: true, href: "" },

    // ],


    // breadcrumbClass: "breadcrumb-style2",
    snackbar: false,
    search: "",
    dialog: false,
    pin_super_master_list: null,
    headers: [
      {
        text: "Pin Code",
        align: "left",
        sortable: false,
        value: "pincode",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    pincode_list: [],
    editedIndex: -1,
    addedItem: {
      pin_super_master_list: "",
    },
    editedItem: {
      id: "",
      pincode: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      pincode: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Pin Code" : "Edit Pin Code";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    //   initialize () {

    //   },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/pinCode")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)

            if ((this.load = true)) {
              this.overlay = false;
              this.pincode_list = res.data.pincode_list;
              this.pin_super_master_list = res.data.pin_super_master_list;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.pincode_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.pincode_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.pincode_list.splice(index, 1)
    // },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editPinCode", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                //window.alert(res.data.msg)
                Object.assign(
                  this.pincode_list[this.editedIndex],
                  this.editedItem
                );
              }
              this.showSnackbar("#4caf50", "Pincode Updated Successfully..."); // show snackbar on success
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/AdmissionMaster/savePinCode", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.pincode_list.push(this.addedItem);
              this.showSnackbar("#4caf50", "Pincode Added Successfully!!!"); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              //window.alert(res.data.status.code)
              this.showSnackbar("#b71c1c", "Pincode Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    isValidated() {
      if (this.editedItem.pincode) {
        return true;
      } else {
        if (!this.editedItem.pincode) {
          this.errorMsg.pincode = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>